<script>
import { MapAgentStationStatus } from "@/common/util";
import PagenationContainer from "@/components/common/PagenationContainer.vue";

import cloneDeep from "lodash/cloneDeep";
import forOwn from "lodash/forOwn";
import moment from "moment";
export default {
  components: {
    PagenationContainer
  },
  data() {
    const ROLE_SUPER_ADMIN =
      localStorage.getItem("roles").indexOf("ROLE_SUPER_ADMIN") > -1;
    const ROLE_AGENT =
      localStorage.getItem("roles").indexOf("ROLE_AGENT") > -1 &&
      !(localStorage.getItem("roles").indexOf("ROLE_AGENT_OPTOMETRIST") > -1);
    const ROLE_REGION_MANAGER =
      localStorage.getItem("roles").indexOf("ROLE_REGION_MANAGER") > -1;
    return {
      ROLE_SUPER_ADMIN,
      ROLE_AGENT,
      ROLE_REGION_MANAGER,
      ProvinceList: [],
      searchFormData: {
        stationName: "",
        stationId: "",
        agentStationState: "",
        provinceCity: "",
        state: ""
      },
      districtArrayRegion: [
        {
          label: "省份搜索",
          keyName: "districtProvince",
          children: []
        },
        {
          label: "",
          keyName: "districtCity",
          children: []
        },
        {
          label: "授权",
          keyName: "agentStationState",
          value: "",
          children: [
            {
              label: "全部",
              keyName: ""
            },
            {
              label: "待授权",
              keyName: "APPLYING"
            },
            {
              label: "已授权",
              keyName: "APPROVED"
            },
            {
              label: "已拒绝",
              keyName: "REFUSED"
            }
          ]
        }
      ],
      tableData: [],
      textInputArray: [
        {
          label: "机构ID",
          keyName: "stationId"
        },
        {
          label: "机构名称",
          keyName: "name"
        }
      ],
      activeSearchArray: [
        {
          label: "机构ID",
          keyName: "stationId",
          type: "text"
        },
        {
          label: "机构名称",
          keyName: "stationName",
          type: "text"
        },
        {
          label: "授权",
          keyName: "agentStationState",
          type: "select",
          value: "",
          children: [
            {
              label: "全部",
              keyName: ""
            },
            {
              label: "待授权",
              keyName: "APPLYING"
            },
            {
              label: "已授权",
              keyName: "APPROVED"
            },
            {
              label: "已拒绝",
              keyName: "REFUSED"
            }
          ]
        },
        {
          label: "省市搜索",
          keyName: "provinceCity",
          children: [],
          type: "cascader"
        }
      ],
      rejectStation: false,
      reviewStation: false,
      defaultValue: {},
      pageCount: 0,
      activePage: 1,
      totalElements: 1
    };
  },
  created() {
    this.loadProvice();
    this.loadData();
  },
  methods: {
    async loadData() {
      let params = {
        page: this.activePage - 1
      };
      for (let key in this.searchFormData) {
        if (key === "provinceCity") {
          if (this.searchFormData[key]) {
            if (this.searchFormData[key][0]) {
              params.provinceId = this.searchFormData[key][0];
            }
            if (this.searchFormData[key][1]) {
              params.districtId = this.searchFormData[key][1];
            }
          }
        } else if (this.searchFormData[key]) {
          params[key] = this.searchFormData[key];
        }
      }
      let data;
      if (this.ROLE_REGION_MANAGER) {
        data = await this.$http.regionGetStationAuthorizeList(params);
        if (data && data.content) {
          this.pageCount = data.totalPages;
          this.totalElements = data.totalElements;
          let newTableData = [];
          data.content.forEach(item => {
            newTableData.push({
              appliedAt: moment(item.appliedAt).format("YYYY-MM-DD"),
              stationId: item.stationId,
              name: item.name,
              district: item.district ? item.district.name : "",
              location: item.location,
              agentName: item.agent.user.name,
              companyName: item.agent.companyName,
              id: item.stationUUID,
              state: item.state,
              agentStationId: item.agentStationId
            });
          });
          this.tableData = newTableData;
        }
      }
      console.log("data::::", params, data);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.activePage = val;
      this.loadData();
    },
    onSearch() {
      this.activePage = 1;
      this.loadData();
    },
    async loadProvice() {
      let ProvinceList = [];
      let province = [];
      if (this.ROLE_REGION_MANAGER) {
        ProvinceList = await this.$http.getProvinceList("regionManager");
        province = this.activeSearchArray;
      }
      if (ProvinceList.length > 0) {
        const provinceChildren = ProvinceList.map(o => {
          return {
            label: o.name,
            keyName: o.id,
            value: o.id,
            children: o.sons.map(o => {
              return {
                label: o.name,
                value: o.id
              };
            }),
            id: o.id,
            name: o.name
          };
        });
        province.forEach(o => {
          if (o.keyName === "provinceCity") {
            o.children = provinceChildren;
          }
        });
        this.ProvinceList = provinceChildren;
      }
    },
    onSearchChange(data) {
      forOwn(data, (value, key) => {
        this.searchFormData[key] = data[key];
      });
    },
    onOperationClick(row, key) {
      this.defaultValue = row;
      switch (key) {
        case "REVIEWED":
          this.reviewStation = true;
          break;
        case "REFUSED":
          this.rejectStation = true;
          break;
      }
    },
    onClickCancel(key) {
      this.defaultValue = {};
      switch (key) {
        case "REVIEWED":
          this.reviewStation = false;
          break;
        case "REFUSED":
          this.rejectStation = false;
          break;
      }
    },
    async onUpdateAccount(formdata, type, row) {
      const updateData = {
        agentStationId: row.agentStationId
      };
      if (type === "REVIEWED") {
        updateData.approved = true;
      } else if (type === "REFUSED") {
        updateData.approved = false;
      }
      let result = await this.$http.regionAuthStation(updateData);
      this.loadData();
      this.defaultValue = {};
    }
  }
};
</script>
<template>
  <div class="impowerManagementIndex">
    <DialogForm
      v-if="reviewStation"
      :defaultValue="defaultValue"
      formTitle="请确认通过审核"
      @close="onClickCancel"
      @submitForm="onUpdateAccount"
      keyOperation="REVIEWED"
      confirmButton="确认"
    />
    <DialogForm
      v-if="rejectStation"
      :defaultValue="defaultValue"
      formTitle="请确认拒绝通过审核"
      @close="onClickCancel"
      @submitForm="onUpdateAccount"
      keyOperation="REFUSED"
      confirmButton="确认"
    />
    <!-- <searchForm
      class="searchForm"
      @onChange="onSearchChange"
      :selectInputArray="districtArrayRegion"
    />
    <searchForm
      class="searchForm"
      showSearch
      @onSearch="onSearch"
      @onChange="onSearchChange"
      :textInputArray="textInputArray"
    />-->
    <searchFormNew
      class="searchForm"
      showSearch
      @onSearch="onSearch"
      @onChange="onSearchChange"
      :searchItemArray="activeSearchArray"
    />
    <div class="statistics">
      <i class="el-icon-info totalResult"></i>
      查询结果：
      <span class="totalResult">{{totalElements}}</span> 个
    </div>
    <el-table
      :data="tableData"
      class="impowerTable"
      :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
      :cell-style="{'padding-left': '5px'}"
    >
      <el-table-column prop="appliedAt" align="left" label="申请时间" width="120"></el-table-column>
      <el-table-column prop="stationId" align="left" label="机构ID" width="120"></el-table-column>
      <el-table-column prop="name" align="left" label="机构名称" width="150"></el-table-column>
      <el-table-column prop="district" align="left" label="所属城市" width="120"></el-table-column>
      <el-table-column prop="location" align="left" label="地址"></el-table-column>
      <el-table-column prop="companyName" align="left" label="代理商" width="120"></el-table-column>
      <el-table-column prop="state" align="left" label="状态" width="200">
        <template slot-scope="scope">
          <span v-if=" scope.row.state === 'APPROVED'">已授权</span>
          <span v-else-if=" scope.row.state === 'REFUSED'">已拒绝</span>
          <span v-else>
            <elementButton size="mini" @click="onOperationClick(scope.row, 'REVIEWED')">授权</elementButton>
            <elementButton
              size="mini"
              type="danger"
              @click="onOperationClick(scope.row, 'REFUSED')"
            >拒绝</elementButton>
          </span>
        </template>
      </el-table-column>
    </el-table>
    <PagenationContainer v-if="pageCount > 1">
      <el-pagination
        @size-change="handleSizeChange"
        background
        @current-change="handleCurrentChange"
        :current-page="activePage"
        :page-count="pageCount"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </PagenationContainer>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.impowerManagementIndex {
  .line {
    width: auto;
    height: 1px;
    background-color: #ebebeb;
    margin: 15px 0;
  }

  .searchForm {
    border: 1px;
    padding-top: 15px;
    height: 50px;
    margin: 0 1%;
    // float: left;
  }
  .statistics {
    float: right;
    margin-right: 30px;
    margin-bottom: 10px;
    // padding-top: 15px;
    margin-top: 10px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 22px;
    .totalResult {
      color: #00c1de;
    }
  }
  .el-pagination {
    text-align: center;
    margin-top: 10px;
  }

  .impowerTable {
    margin: 20px 1%;
    border: 1px;
    width: 98%;
    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
    th > .cell {
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/impowerManagement/index.vue